<template>
    <div class="oktober-news">
        <img
            src="/img/OKtober-banner.jpg"
            alt="OKtober"
            class="w-full"
        >

        <!-- Call To Action -->
        <a
            href="https://www.swisslens.ch/de/allevent/?slview=list&sldate=&slf%5B_ecp_custom_2%5D%5B%5D=German&slf%5B_ecp_custom_5%5D%5B%5D=Online"
            target="_blank"
            class="oktober-news__cta"
        >
            {{ t('news.sl_academy.cta') }}
        </a>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });
</script>

<style scoped>
@reference "#main.css";

.oktober-news
{
    @apply relative rounded-lg overflow-hidden;
}

.oktober-news__cta
{
    @apply absolute bottom-5 right-5 rounded px-6 py-3 shadow-lg
        bg-[#e0dd04] text-primary-900 transition;

    &:hover
    {
        @apply scale-105 shadow-xl;
    }
}
</style>
